import { CloudinaryImage } from '#src/components/CloudinaryImage';
import {
  flattenResponsiveImage,
  flattenResponsiveVideo,
  getWbAssetUrl,
  selectFields,
} from '#src/lib/contentful/selectors.mjs';
import { ResponsiveVideo } from '#src/components/ResponsiveVideo/index.js';

export const mediaComponentsMap = {
  responsiveImage: ({ mediaRow, ...props }) => (
    <CloudinaryImage {...flattenResponsiveImage(mediaRow)} {...props} />
  ),
  responsiveVideo: ({ mediaRow, ...props }) => {
    const videos = flattenResponsiveVideo(mediaRow);
    const poster = getWbAssetUrl(
      selectFields(mediaRow?.fields?.posterImage)?.file?.url
    );

    return (
      <ResponsiveVideo
        videos={videos}
        autoPlay={true}
        loop={true}
        muted={true}
        playsInline={true}
        poster={poster}
        {...props}
      />
    );
  },
};
